export default __webpack_public_path__ + "static/media/boton-bancolombia.e54e8824.svg";